/* ==========================================================================
   Mori Scratch Card Popup — teaser sekmesine kapatma (x) dugmesi

   KONUMLANDIRMA MANTIGI  (v3 — zoom hatasi giderildi, gorunum korundu)

   Eski surum x'i EKRAN koordinatina gore hesapliyordu:
       maxSol = window.innerWidth - r.left - BOYUT - KENAR
   iOS Safari'de parmakla zoom yapilinca window.innerWidth GORSEL viewport'a
   duser (375 -> 188), ama getBoundingClientRect() LAYOUT viewport'ta kalir.
   Iki farkli birim ayni formulde bulusunca x ekranin ortasina firliyordu.
   Ayni sekilde teaser animasyon sirasinda olculup r.top negatif cikarsa
   "ust = KENAR - r.top" x'i sekmenin ortasina indiriyordu.

   YENI MANTIK: x zaten teaser'in COCUGU, yani teaser nereye giderse onunla
   birlikte gider. Konum teaser'in KENDI kutusuna gore veriliyor — gorunum
   ilk surumdeki gibi: YATAYDA sekmenin ortasi, DIKEYDE ust kenarinin hemen
   uzeri. Fark su ki sonuc sert sinirlanmis:

       sol  ∈ [ -(BOYUT+KENAR) , r.width + KENAR ]
       ust  ∈ [ -(BOYUT+KENAR) , BOYUT ]

   Yani x her kosulda sekmenin ust kenarinin ~26px cevresinde kalir. Zoom,
   kaydirma, ekran donmesi, giris animasyonu — hicbiri onu ortaya firlatamaz.

   Ekran genisligi yalnizca sekme ekranin sagindan tasiyorsa x'i iceri cekmek
   icin okunur, o da document.documentElement.clientWidth ile (layout viewport,
   parmakla zoom'dan etkilenmez).

   Uygulamanin DOM'u:
     #sp-teaser-tab   -> <button>, body'nin dogrudan cocugu, position:fixed
     #scratch-popup   -> kazi-kazan penceresi, acikken .sp-show sinifi alir

   Dosya: assets/scratch-teaser-close.js
   theme.liquid icinde </body> etiketinden HEMEN ONCE:
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------- AYARLAR ----------------------------- */

  // 'session' -> sekme kapanana kadar gizli kalir (musteri tekrar girince geri gelir)
  // 'days'    -> HATIRLA_GUN kadar gizli kalir
  var HATIRLAMA = 'session';
  var HATIRLA_GUN = 7;

  var BOYUT = 22;   // x'in gorunen capi (px). Dokunma alani ayrica 44px'e cikarilir.
  var KENAR = 4;    // teaser kenarindan mesafe (px)

  /* ------------------------------------------------------------------- */

  var KEY = 'sp-teaser-kapatildi';
  var TEASER = '#sp-teaser-tab';
  var POPUP = '#scratch-popup';

  function kapaliMi() {
    try {
      if (HATIRLAMA === 'session') return sessionStorage.getItem(KEY) === '1';
      var v = localStorage.getItem(KEY);
      return !!v && Date.now() < parseInt(v, 10);
    } catch (e) {
      return false;
    }
  }

  function kapaliIsaretle() {
    try {
      if (HATIRLAMA === 'session') sessionStorage.setItem(KEY, '1');
      else localStorage.setItem(KEY, String(Date.now() + HATIRLA_GUN * 864e5));
    } catch (e) {
      /* gizli sekmede storage kapali olabilir */
    }
  }

  /* Teaser'in GERCEK zemin rengini bulur (seffafsa ust ogeye bakar,
     gradient ise ilk rengi alir) ve parlakligina gore x'in rengini secer.
     Boylece teaser acik pembe de olsa koyu siyah da olsa x her zaman okunur. */
  function zeminRengi(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      var cs = getComputedStyle(node);
      var bg = cs.backgroundColor;
      if (bg && !/rgba?\(0,\s*0,\s*0,\s*0\)|transparent/.test(bg)) return bg;
      var bi = cs.backgroundImage;
      if (bi && bi !== 'none') {
        var m = bi.match(/rgba?\([^)]+\)/);
        if (m) return m[0];
      }
      node = node.parentElement;
    }
    return 'rgb(255,255,255)';
  }

  function acikMi(renk) {
    var m = String(renk).match(/(\d+(?:\.\d+)?)/g);
    if (!m || m.length < 3) return true;
    var r = +m[0], g = +m[1], b = +m[2];
    // algisal parlaklik
    return (0.299 * r + 0.587 * g + 0.114 * b) > 150;
  }

  function stilEkle(teaser) {
    var acik = acikMi(zeminRengi(teaser));
    var daireBg = acik ? '#1f1f27' : '#ffffff';
    var isaretRenk = acik ? '#ffffff' : '#1f1f27';

    var eski = document.getElementById('sp-teaser-close-style');
    if (eski) eski.remove();

    var s = document.createElement('style');
    s.id = 'sp-teaser-close-style';
    s.textContent =
      '.sp-teaser-close{' +
      'position:absolute;' +
      'width:' + BOYUT + 'px;height:' + BOYUT + 'px;' +
      'display:flex;align-items:center;justify-content:center;' +
      'border-radius:50%;cursor:pointer;z-index:5;' +
      'writing-mode:horizontal-tb;text-orientation:mixed;' +
      'background:' + daireBg + ';color:' + isaretRenk + ';' +
      'box-shadow:0 1px 5px rgba(0,0,0,.22);' +
      'transition:transform .15s ease;' +
      '-webkit-tap-highlight-color:transparent;}' +
      /* dokunma alanini 44px'e cikarir, gorseli buyutmeden */
      '.sp-teaser-close::before{content:"";position:absolute;inset:-11px;}' +
      '.sp-teaser-close:hover{transform:scale(1.12);}' +
      '.sp-teaser-close:focus-visible{outline:2px solid ' + daireBg + ';outline-offset:2px;}' +
      '.sp-teaser-close svg{display:block;width:' + Math.round(BOYUT * 0.42) + 'px;height:' + Math.round(BOYUT * 0.42) + 'px;}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* --------------------------- KONUMLANDIRMA -------------------------- */

  function sinirla(deger, alt, ust) {
    return Math.max(alt, Math.min(deger, ust));
  }

  function konumla(teaser, x) {
    var r = teaser.getBoundingClientRect();
    if (!r.width || !r.height) return;

    /* Layout viewport genisligi. window.innerWidth KULLANILMAZ — iOS'ta
       parmakla zoom yapilinca o deger gorsel viewport'a duser ve rect ile
       ayni birimde olmaz. clientWidth zoom'dan etkilenmez. */
    var lw = document.documentElement.clientWidth || 0;

    /* YATAY: sekmenin kendi ortasi. */
    var sol = (r.width - BOYUT) / 2;

    /* Sekme ekranin sagindan tasiyorsa ("peek" sekme) x'i iceri cek ki
       tiklanabilir kalsin. lw zoom'dan etkilenmedigi icin guvenli. */
    if (lw > 0 && r.left + sol + BOYUT > lw - KENAR) sol = lw - KENAR - BOYUT - r.left;
    if (lw > 0 && r.left + sol < KENAR) sol = KENAR - r.left;

    /* DIKEY: sekmenin ust kenarinin hemen uzeri. r.top'a BAKILMAZ —
       eski surumde x'i sekmenin ortasina indiren tam olarak o hesapti. */
    var ust = -Math.round(BOYUT * 0.55);

    /* Sert sinir: x hicbir kosulda sekmenin ust kenarinin ~26px cevresinden
       disari cikamaz. Olcum hatali gelse bile ortaya firlamasi imkansiz. */
    sol = sinirla(sol, -(BOYUT + KENAR), r.width + KENAR);
    ust = sinirla(ust, -(BOYUT + KENAR), BOYUT);

    x.style.left = Math.round(sol) + 'px';
    x.style.top = Math.round(ust) + 'px';
  }

  /* Kapatmaya basildiktan sonra popup yine de acilirsa geri kapat.
     Uygulamanin tiklamayi nasil bagladigina bagli olmayan emniyet katmani. */
  function popupAcilirsaKapat() {
    var bitis = Date.now() + 600;
    function dene() {
      if (Date.now() > bitis) return;
      var p = document.querySelector(POPUP);
      if (p && p.classList.contains('sp-show')) {
        var btn = p.querySelector('.sp-close, [class*="close"], [aria-label*="lose"], [aria-label*="apat"]');
        if (btn) btn.click();
        else p.classList.remove('sp-show');
        return;
      }
      requestAnimationFrame(dene);
    }
    requestAnimationFrame(dene);
  }

  function gizle(teaser) {
    kapaliIsaretle();
    teaser.style.transition = 'opacity .2s ease';
    teaser.style.opacity = '0';
    teaser.style.pointerEvents = 'none';
    setTimeout(function () {
      teaser.style.display = 'none';
    }, 220);
    popupAcilirsaKapat();
  }

  function dugmeEkle(teaser) {
    if (!teaser || teaser.dataset.spCloseHazir === '1') return;
    teaser.dataset.spCloseHazir = '1';

    if (kapaliMi()) {
      teaser.style.display = 'none';
      return;
    }

    stilEkle(teaser);

    var x = document.createElement('span');
    x.className = 'sp-teaser-close';
    x.setAttribute('role', 'button');
    x.setAttribute('tabindex', '0');
    x.setAttribute('aria-label', 'Kapat');
    x.innerHTML =
      '<svg viewBox="0 0 10 10" aria-hidden="true" focusable="false">' +
      '<path d="M1.2 1.2l7.6 7.6M8.8 1.2l-7.6 7.6" stroke="currentColor" ' +
      'stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';

    function tiklandi(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      gizle(teaser);
    }

    /* Yakalama fazi: olay teaser butonuna ulasmadan burada durur. */
    ['pointerdown', 'mousedown', 'click', 'touchstart'].forEach(function (tip) {
      x.addEventListener(tip, tiklandi, true);
    });
    x.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') tiklandi(e);
    });

    teaser.appendChild(x);
    konumla(teaser, x);

    /* x teaser'in cocugu oldugu icin onunla birlikte hareket eder; yeniden
       olcum sadece "sag mi sol mu" kararini tazelemek icin gerekir. */
    var yenidenOlc = function () { konumla(teaser, x); };

    window.addEventListener('resize', yenidenOlc);
    window.addEventListener('orientationchange', function () {
      setTimeout(yenidenOlc, 250);
    });
    teaser.addEventListener('transitionend', yenidenOlc);
    if (window.ResizeObserver) new ResizeObserver(yenidenOlc).observe(teaser);
    [80, 400, 1000].forEach(function (ms) { setTimeout(yenidenOlc, ms); });
  }

  function tara() {
    var t = document.querySelector(TEASER);
    if (t) dugmeEkle(t);
  }

  tara();

  /* Teaser gec geliyor (popup kapatilinca olusuyor) — olusunca yakala. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(tara);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
})();